import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardHeader } from '../components/CardHeader/CardHeader';
import { CardBody } from '../components/CardBody/CardBody';
import { Input } from '../components/Input/Input';
import { Select } from '../components/Select/Select';
import { Col, Row, Spinner, Button, Container, Modal, Form, Alert } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { api } from '../services/Api';
import {useHistory, useParams} from 'react-router-dom';
import { getCurrentMonthAndYear } from '../Utils/currentDate';
import { useAlert } from '../contexts/AlertContext';
import {cvvCardMask, numberCreditCardMask, validateCardMask} from '../Utils/Mask';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import QRCode from "react-qr-code";
import {formatDate} from "../Utils/formatDate";
import {useAuth} from "../contexts/AuthenticationContext";
import Navbar from "react-bootstrap/Navbar";
import logoImg from "../assets/netcomet.png";

type CreditCard = {
	bandeira: string;
	id: number;
	numero: string;
	validade: string;
}

type Invoice = {
	cartoes: CreditCard[];
	data_vencimento: string;
	id: number;
	nome: string;
	numero_documento: string;
	numero_maximo_parcelas: number;
	plano: string;
	valor_documento: number;
	valor_juros: number;
	valor_multa: number;
	valor_total: number;
}
export function SinglePayment() {
	const history = useHistory();

	const { session } = useAuth();

	const { paymentId } = useParams<{paymentId?: string}>();
	const { handleSetAlert } = useAlert();

	const [invoice, setInvoice] = useState<Invoice | null>(null);

	const [creditCards, setCreditCards] = useState<CreditCard[] | null>(null);
	const [payment, setPayment] = useState<string | null>(null);
	const [cardSelected, setCardSelected] = useState<string | boolean>(false);
	const [numberCardSelected, setNumberCardSelected] = useState<string>('');
	const [nameCardSelected, setNameCardSelected] = useState<string>('');
	const [flagCardSelected, setFlagCardSelected] = useState<string>('');
	const [validateCardSelected, setValidateCardSelected] = useState<string>('');
	const [cvvCardSelected, setCvvCardSelected] = useState<string>('');
	const [maximumInstallmentsCardSelected, setMaximumInstallmentsCardSelected] = useState<string>('');
	const [saveCard, setSaveCard] = useState<boolean>(false);
	const [installments, setInstallments] = useState<number>(0);
	const [loadingInvoice, setLoadingInvoice] = useState<boolean>(false);
	const [clientId, setClientId] = useState<number | null>(null);
	const [emailModal, setEmailModal] = useState<boolean>(false);
	const [emailModalLoading, setEmailModalLoading] = useState<boolean>(false);
	const [emailModalMessage, setEmailModalMessage] = useState<string | null>(null);
	const [emailModalStatus, setEmailModalStatus] = useState<boolean>(false);
	const [email, setEmail] = useState<string>('');
	const [emailValidation, setEmailValidation] = useState<boolean>(true);
	const [pixModal, setPixModal] = useState<boolean>(false);
	const [pixModalLoading, setPixModalLoading] = useState<boolean>(false);
	const [paymentModal, setPaymentModal] = useState<boolean>(false);
	const [paymentModalLoading, setPaymentModalLoading] = useState<boolean>(false);

	const [pixModalAlert, setPixModalAlert] = useState<string | null>(null);
	const [pixModalAlertIconName, setPixModalAlertIconName] = useState<string | null>(null);
	const [pixModalAlertMessage, setPixModalAlertMessage] = useState<string | null>(null);
	const [pixModalCancel, setPixModalCancel] = useState<boolean>(false);
	const [pixModalQRCODE, setPixModalQRCODE] = useState<string | null>(null);

	const [paymentModalAlert, setPaymentModalAlert] = useState<string | null>(null);
	const [paymentModalAlertIconName, setPaymentModalAlertIconName] = useState<string | null>(null);
	const [paymentModalAlertMessage, setPaymentModalAlertMessage] = useState<string | null>(null);
	const [paymentModalCancel, setPaymentModalCancel] = useState<boolean>(false);


	useEffect(() => {
		if(session){
			setLoadingInvoice(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/financeiro/movimentacoes/cobranca-avulsa/'+paymentId, { headers })
				.then((response) => {
					setInvoice(response.data);
					setCreditCards(response.data.cartoes);
					setInstallments(response.data.numero_maximo_parcelas);
					setLoadingInvoice(false);
				})
				.catch(error => {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: error.response.data.message,
						timeout: 5000
					});
					setLoadingInvoice(false);
					history.push('/menu');
				});
		}
	}, [session, paymentId, history, handleSetAlert])

	function handlePaymentEmail(){
		if (payment==="credit_card" && !cardSelected) {
			let dateCard = '' as any;
			if (validateCardSelected) {
				dateCard = validateCardSelected.split('/');
				if (!dateCard[1]) {
					dateCard = dateCard[0];
				} else {
					dateCard = dateCard[1]+dateCard[0];
				}
			}

			if (!numberCardSelected) {
				handleSetAlert({
					visible: true,
					variant: 'warning',
					message: "Digite o número do cartão",
					timeout: 5000
				});
				return false;
			} else if (!nameCardSelected) {
				handleSetAlert({
					visible: true,
					variant: 'warning',
					message: "Digite o nome inserido no cartão",
					timeout: 5000
				});
				return false;
			} else if (!flagCardSelected) {
				handleSetAlert({
					visible: true,
					variant: 'warning',
					message: "Insira a bandeira do cartão",
					timeout: 5000
				});
				return false;
			} else if (!validateCardSelected) {
				handleSetAlert({
					visible: true,
					variant: 'warning',
					message: "Insira a validade do cartão",
					timeout: 5000
				});
				return false;
			} else if (validateCardSelected.length < 7) {
				handleSetAlert({
					visible: true,
					variant: 'warning',
					message: "Validade do cartão inválida, informe a data com o ano completo",
					timeout: 5000
				});
				return false;
			} else if (parseInt(dateCard) < parseInt(getCurrentMonthAndYear())) {
				handleSetAlert({
					visible: true,
					variant: 'warning',
					message: "Validade do cartão inválida",
					timeout: 5000
				});
				return false;
			} else if (!cvvCardSelected) {
				handleSetAlert({
					visible: true,
					variant: 'warning',
					message: "Insira o código de segurança do cartão",
					timeout: 5000
				});
				return false;
			}
		}

		if(session){
			setEmailModal(true);
			setEmailModalLoading(true);
			setEmailModalMessage(null);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/pessoas/clientes/perfil', { headers })
				.then((response: any) => {
					let emailModal = false;
					let modal = true;
					let modalLoading = true;
					if (!handleEmailValidation(response.data.email)) {
						emailModal = true;
						modal = false;
						modalLoading = false;
						setEmailModalLoading(false);
					} else {
						setEmail(response.data.email);
					}

					setEmailModal(emailModal);
					setEmailModalStatus(true);
					setClientId(response.data.id);

					if(payment==="pix"){
						setPixModal(modal);
						setPixModalLoading(modalLoading);
					}
					if(payment==="credit_card"){
						setPaymentModal(modal);
						setPaymentModalLoading(modalLoading);
					}
					if (handleEmailValidation(response.data.email)) {
						if(payment==="pix"){
							handlePaymentPIX();
						}
						if(payment==="credit_card"){
							handlePaymentCreditCard();
						}
					}
				});
		}
	}

	function handlePaymentEmailRegister(){
		if(session){
			if (!email) {
				handleSetAlert({
					visible: true,
					variant: 'warning',
					message: 'Informe o email a ser cadastrado',
					timeout: 5000
				});
				return false;
			}

			setEmailModal(true);
			setEmailModalLoading(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			let emails = [];
			emails.push(email);

			api.post('v1/pessoas/clientes/cadastrar-emails', JSON.stringify({id: clientId, emails: emails}), { headers })
				.then((responseJson: any) => {
					if (responseJson.data.status !== 1){
						setEmailModalLoading(false);
						setEmailModalMessage(responseJson.data.message);
						setEmailModalStatus(false);
					} else {
						setEmailModal(false);
						setEmailModalLoading(false);
						setEmailModalMessage(null);

						if(payment==="pix"){
							setPixModal(true);
							setPixModalLoading(true);
							handlePaymentPIX();
						}
						if(payment==="credit_card"){
							setPaymentModal(true);
							setPaymentModalLoading(true);
							handlePaymentCreditCard();
						}
					}
				})
				.catch(() => {
					setEmailModalLoading(false);
					setEmailModalMessage('Não foi possível cadastrar, verifique o email e tente novamente');
					setEmailModalStatus(false);
				});
		}
	}

	function handlePaymentPIX(){
		if(session){
			setPixModal(true);
			setPixModalLoading(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			let data = {
				"movimentacoes": [paymentId],
				"id_meio_de_pagamento": 29
			}

			api.post('v1/financeiro/movimentacoes/cobranca-avulsa-pix', data, { headers })
				.then((responseJson: any) => {
					if(responseJson.data.status !== 1){
						setPixModalLoading(false);
						setPixModalAlert('danger');
						setPixModalAlertIconName('clear');
						setPixModalAlertMessage('Não foi possivel executar a operação. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
						setPixModalCancel(false);
					}else{
						let  pixModalQRCODE = null;
						if(responseJson.data.dados[0].pix_qrcode){
							pixModalQRCODE = responseJson.data.dados[0].pix_qrcode;
						}
						if(!pixModalQRCODE && responseJson.data.dados[0].view_url){
							pixModalQRCODE = responseJson.data.dados[0].view_url;
						}

						if(pixModalQRCODE){
							setPixModalLoading(false);
							setPixModalAlert('success');
							setPixModalAlertIconName('check');
							setPixModalAlertMessage(responseJson.data.message);
							setPixModalCancel(true);
							setPixModalQRCODE(pixModalQRCODE)
						}else{
							setPixModalLoading(false);
							setPixModalAlert('danger');
							setPixModalAlertIconName('clear');
							setPixModalAlertMessage('Não foi possivel executar a operação. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
							setPixModalCancel(false);
						}
					}
				}).catch(() => {
					setPixModalLoading(false);
					setPixModalAlert('danger');
					setPixModalAlertIconName('clear');
					setPixModalAlertMessage('Não foi possivel executar a operação. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
					setPixModalCancel(false);
				});
		}
	}

	function handlePaymentCreditCard(){
		setPaymentModal(true);
		setPaymentModalLoading(true);

		let dateCard = [];
		if (!cardSelected) {
			dateCard = validateCardSelected.split('/');
		} else {
			dateCard[0] = null;
			dateCard[1] = null;
		}

		let data = {
			id: paymentId,
			id_gateway: 2,
			id_meio_de_pagamento: 28,
			id_pessoa_cartao: cardSelected,
			bandeira: flagCardSelected,
			numero: numberCardSelected,
			nome: nameCardSelected,
			cvv: cvvCardSelected,
			mes: dateCard[0],
			ano: dateCard[1],
			salvar_cartao: saveCard,
			notificar_cliente: false,
			numero_parcelas: maximumInstallmentsCardSelected,
		}

		const headers = {
			'Authorization': 'Beaser '+session?.token,
			'Content-Type': 'application/json',
		};

		api.post('v1/financeiro/movimentacoes/cobranca-avulsa-cartao', data, { headers })
			.then((responseJson) => {
				if (responseJson.data.status === 0){
					setPayment(null);
					setPaymentModalLoading(false);
					setPaymentModalAlert('danger');
					setPaymentModalAlertIconName('clear');
					setPaymentModalAlertMessage('Não foi possivel executar a operação. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
					setPaymentModalCancel(false);
				} else {
					let attempts = 0;
					let interval = setInterval(async () => {

						let invoice: { data: {id_status: null} };
						invoice = await api.get('v1/financeiro/movimentacoes/'+paymentId,{ headers });

						attempts++;
						if (attempts >= 4 || invoice.data.id_status !== 30) {
							if (invoice.data.id_status === 20 || invoice.data.id_status === 21) {
								setPaymentModalLoading(false);
								setPaymentModalAlert('success');
								setPaymentModalAlertIconName('check');
								setPaymentModalAlertMessage('Pagamento processado e efetuado com sucesso na plataforma de cobrança (IUGU)');
								setPaymentModalCancel(true);
							}else if (invoice.data.id_status === 31) {
								setPayment(null)
								setPaymentModalLoading(false);
								setPaymentModalAlert('danger');
								setPaymentModalAlertIconName('clear');
								setPaymentModalAlertMessage('Não foi possivel executar a operação. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
								setPaymentModalCancel(false);
							} else {
								setPaymentModalLoading(false);
								setPaymentModalAlert('primary');
								setPaymentModalAlertIconName('info');
								setPaymentModalAlertMessage('Pagamento em processamento na plataforma de cobrança (IUGU), enviaremos uma mensagem para o seu telefone com a confirmação');
								setPaymentModalCancel(true);
							}
							clearInterval(interval);
						}
					},5000)
				}
			}).catch(() => {
				setPayment(null);
				setPaymentModalLoading(false);
				setPaymentModalAlert('danger');
				setPaymentModalAlertIconName('clear');
				setPaymentModalAlertMessage('Não foi possivel executar a operação. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
				setPaymentModalCancel(false);
			});
	}

	function handleEmail(value: string){
		if (value.length === 0) {
			setEmail('');
		} else {
			if (handleEmailValidation(value)) {
				setEmailValidation(true);
			} else {
				setEmailValidation(false);
			}
			setEmail(value);
		}
	}

	function handleEmailValidation(email: string){
		return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
	}

	return(
		<>
			<Navbar collapseOnSelect style={{height: 80}} className="header p1" expand="lg">
				<Container>
					<Navbar.Brand>
						<img src={logoImg} alt="Logo Netcomet"/>
					</Navbar.Brand>
					<a href="https://cliente.netcomet.com.br/login" rel="noreferrer" target="_blank">
						<Navbar.Brand className="d-flex align-items-center color-dark-gray">
							<span className="material-icons title-icon">face</span>
							<p className="m-0">Portal do Cliente</p>
						</Navbar.Brand>
					</a>
				</Container>
			</Navbar>
			<Container className="container-login p-3">
				<Row>
					<Col md={6}>
						<Row className="m-card">
							<Col md={12} className="d-flex justify-content-center">
								<CardInfo variant="w-100">
									<CardHeader variant="text-center card-header-info">
										<div className="d-flex align-items-center">
											<span className="material-icons title-icon">monetization_on</span>
											Fatura
										</div>
									</CardHeader>
									<CardBody>
										<Row className="d-flex m-0">
											{loadingInvoice && <div className="justify-content-center align-items-center d-flex">
												<Spinner animation="border" role="status"/>
											</div>
											}
											{!loadingInvoice && <Col md={12}>
												<p><b>Nome: </b>{invoice?.nome}</p>
												<p><b>Número do Documento: </b>{invoice?.numero_documento}</p>
												<p><b>Plano: </b>{invoice?.plano}</p>
												<p><b>Data de Vencimento: </b>{invoice?.data_vencimento ? formatDate(invoice?.data_vencimento) : ''}</p>
												<p><b>Valor do Documento: </b>R$ {invoice?.valor_documento.toFixed(2)}</p>
												<p><b>Valor do Juros: </b>R$ {invoice?.valor_juros.toFixed(2)}</p>
												<p><b>Valor da Multa: </b>R$ {invoice?.valor_multa.toFixed(2)}</p>
												<p><b>Valor Total: </b>R$ {invoice?.valor_total.toFixed(2)}</p>
											</Col>
											}
										</Row>
									</CardBody>
								</CardInfo>
							</Col>
						</Row>
					</Col>
					<Col md={6}>
						<Row className="m-card">
							<Col md={12} className="d-flex justify-content-center">
								<CardInfo variant="w-100">
									<CardHeader variant="text-center card-header-info">
										<div className="d-flex align-items-center">
											<span className="material-icons title-icon">payments</span>
											Pagamento
										</div>
									</CardHeader>
									<CardBody>
										<Row className="m-0">
											{!payment && loadingInvoice && <div className="justify-content-center align-items-center d-flex p-2">
												<Spinner animation="border" role="status"/>
											</div>
											}
											{!payment && !loadingInvoice && <>
												<Col md={6} sm={6} xs={6} className="mb-3">
													<div className="d-grid gap-2">
														<Button variant="primary d-flex justify-content-center align-items-center" onClick={() => setPayment('pix')}>
															<span className="material-icons title-icon">pix</span>
															PIX
														</Button>
													</div>
												</Col>
												<Col md={6} sm={6} xs={6} className="mb-3">
													<div className="d-grid gap-2">
														<Button variant="primary d-flex justify-content-center alig align-items-center" onClick={() => setPayment('credit_card')}>
															<span className="material-icons title-icon">credit_card</span>
															CARTÃO
														</Button>
													</div>
												</Col>
											</>}
											{payment === 'credit_card' && !loadingInvoice && <>
												<div>
													<Col md={12} sm={12} xs={12}>
														<div className="mb-4 w-100">
															<p className="m-0"><b>Selecione o seu cartão para realizar o pagamento: </b></p>
														</div>
													</Col>
												</div>
												<div>
													<Col md={12} sm={12} xs={12}>
														<div className="mb-4 w-100">
															<Select
																icon="payment"
																onChange={(value) => {setCardSelected(value.target.value)}}
															>
																<option value="">SELECIONE O CARTÃO</option>
																{creditCards?.map((card, key) => (
																	<option value={card.id} key={key} selected={cardSelected === card.numero}>{card.numero}</option>
																))}
															</Select>
														</div>
													</Col>
												</div>
												{!cardSelected && <>
													<div>
														<Col md={12} sm={12} xs={12}>
															<div className="mb-4 w-100">
																<p className="m-0"><b>Ou cadastre um novo cartão de crédito: </b></p>
															</div>
														</Col>
													</div>
													<div>
														<Col md={12} sm={12} xs={12}>
															<div className="mb-4 w-100">
																<Input
																	icon="payment"
																	type="text"
																	placeholder="NÚMERO DO CARTÃO DE CRÉDITO"
																	onChange={(value) => {setNumberCardSelected(numberCreditCardMask(value.target.value))}}
																	value={numberCardSelected}
																/>
															</div>
														</Col>
													</div>
													<div>
														<Col md={12} sm={12} xs={12}>
															<div className="mb-4 w-100">
																<Input
																	icon="face"
																	type="text"
																	placeholder="NOME NO CARTÃO DE CRÉDITO"
																	onChange={(value) => {setNameCardSelected(value.target.value.toUpperCase())}}
																	value={nameCardSelected}
																/>
															</div>
														</Col>
													</div>
													<div>
														<Col md={12} sm={12} xs={12}>
															<div className="mb-4 w-100">
																<Select
																	icon="flag"
																	onChange={(value) => {setFlagCardSelected(value.target.value)}}
																>
																	<option value="">SELECIONE A BANDEIRA</option>
																	<option value="Visa">Visa</option>
																	<option value="Master">Master</option>
																	<option value="Elo">Elo</option>
																</Select>
															</div>
														</Col>
													</div>
													<div className="d-flex">
														<Col md={6} sm={6} xs={6}>
															<div className="mb-4 w-100">
																<Input
																	icon="calendar_today"
																	type="text"
																	placeholder="VALIDADE"
																	onChange={(value) => {setValidateCardSelected(validateCardMask(value.target.value))}}
																	value={validateCardSelected}
																/>
															</div>
														</Col>
														<Col md={6} sm={6} xs={6}>
															<div className="mb-4 w-100">
																<Input
																	icon="lock"
																	type="text"
																	placeholder="CVV"
																	onChange={(value) => {setCvvCardSelected(cvvCardMask(value.target.value))}}
																	value={cvvCardSelected}
																/>
															</div>
														</Col>
													</div>
													{installments > 0 &&
														<div>
															<Col md={12} sm={12} xs={12}>
																<div className="mb-4 w-100">
																	<Select
																		icon="schedule"
																		onChange={(value) => {setMaximumInstallmentsCardSelected(value.target.value)}}
																	>
																		<option value="">SELECIONE O NÚMERO DE PARCELAS</option>
																		{Array(invoice?.numero_maximo_parcelas).fill(null).map((item, key) => (
																			<option value={key+1} key={key}>{(key+1)+"x"}</option>
																		))}
																	</Select>
																</div>
															</Col>
														</div>
													}
													<div>
														<Col md={12} sm={12} xs={12}>
															<div className="mb-4 w-100">
																<Form.Group>
																	<Form.Check type="checkbox" onClick={() => saveCard ? setSaveCard(false) : setSaveCard(true)} className="title" label="Salvar o seu cartão para futuros pagamentos" />
																</Form.Group>
															</div>
														</Col>
													</div>
												</>}
												{cardSelected && installments > 0 &&
													<div>
														<Col md={12} sm={12} xs={12}>
															<div className="mb-4 w-100">
																<Select
																	icon="schedule"
																	onChange={(value) => {setMaximumInstallmentsCardSelected(value.target.value)}}
																>
																	<option value="">SELECIONE O NÚMERO DE PARCELAS</option>
																	{Array(invoice?.numero_maximo_parcelas).fill(null).map((item, key) => (
																		<option value={key+1} key={key}>{(key+1)+"x"}</option>
																	))}
																</Select>
															</div>
														</Col>
													</div>
												}
												<div>
													<Col md={12} sm={12} xs={12}>
														<div className="mb-4 w-100">
															<Button variant="primary d-flex justify-content-center" onClick={() => {setPayment('credit_card'); handlePaymentEmail()}} className="w-100">
																Efetuar Pagamento
															</Button>
															<Button variant="light d-flex justify-content-center mt-3" onClick={() => {setPayment(null);}} className="w-100">
																Voltar
															</Button>
														</div>
													</Col>
												</div>
											</>}
											{payment === 'pix' && !loadingInvoice && <>
												<div>
													<Col md={12} sm={12} xs={12}>
														<div className="mb-4 w-100">
															<p className="m-0"><b>Clique no botão abaixo para gerar o PIX QRCODE e PIX COPIA E COLA para pagar no aplicativo do seu banco digital</b></p>
														</div>
													</Col>
												</div>
												<div>
													<Col md={12} sm={12} xs={12}>
														<div className="mb-4 w-100">
															<p className="m-0">Após o pagamento no seu banco digital o status da sua fatura poderá demorar alguns momentos para ser atualizado</p>
														</div>
													</Col>
												</div>
												<div>
													<Col md={12} sm={12} xs={12}>
														<div className="mb-4 w-100">
															<Button variant="primary d-flex justify-content-center" onClick={() => {setPayment('pix'); handlePaymentEmail()}} className="w-100">
																Gerar Pix
															</Button>
															<Button variant="light d-flex justify-content-center mt-3" onClick={() => {setPayment(null);}} className="w-100">
																Voltar
															</Button>
														</div>
													</Col>
												</div>
											</>}
										</Row>
									</CardBody>
								</CardInfo>
							</Col>
						</Row>
					</Col>
				</Row>
			</Container>

			{/* CADASTRAR EMAIL */}
			<Modal show={emailModal} onHide={() => {return false}} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header className="justify-content-center border-bottom-0">
					<Modal.Title id="contained-modal-title-vcenter">
						{emailModalLoading ? 'Verificando email cadastrado' : 'Cadastrar Email'}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<Container>
						{emailModalLoading && <div className="justify-content-center align-items-center text-center p-2">
							<Spinner animation="border" role="status"/>
							<p className="mt-4">Executando operação, aguarde um momento</p>
						</div>
						}
						{!emailModalLoading && <div>
							{emailModalMessage && !emailModalStatus && <Row>
								<Alert className="d-flex" variant={!emailModalStatus ? "danger" : "success"}>
									<Col md={2} className="justify-content-center align-items-center d-flex">
										<span className="material-icons alert-icon">{!emailModalStatus ? 'clear' : 'check'}</span>
									</Col>
									<Col md={10} className="align-items-center d-flex">
										<p className="p-0 m-0 color-white">{emailModalMessage}</p>
									</Col>
								</Alert>
							</Row>}
							{emailModalStatus && <Row>
								<Col md={12}>
									<h6 className="text-center">Cadastre seu email abaixo e salve para continuar o pagamento</h6>
									<Col md={12}>
										<div className="d-flex justify-content-center w-100 align-items-center flex-column">
											<div className="p-3 w-100">
												<Input
													icon="email"
													type="text"
													placeholder="Digite o seu email"
													onChange={(value) => {handleEmail(value.target.value)}}
													value={email}
												/>
											</div>
										</div>
									</Col>
									{!emailValidation && <Col md={12}>
										<Alert className="d-flex" variant={"warning"}>
											<Col md={12} className="align-items-center d-flex">
												<p className="p-0 m-0 color-white">E-mail inválido</p>
											</Col>
										</Alert>
									</Col>}
								</Col>
							</Row>}
						</div>
						}
					</Container>
				</Modal.Body>
				{!emailModalLoading && <Modal.Footer className="border-top-0">
					<Button variant="light" onClick={() => {setEmailModal(false); setPayment(null); setEmailValidation(true); setEmail('')}}>Fechar</Button>
					{emailModalStatus && <Button variant="primary" disabled={!emailValidation || !email} onClick={() => handlePaymentEmailRegister()}>Cadastrar</Button>}
				</Modal.Footer>}
			</Modal>

			{/* PAGAMENTO PIX */}
			<Modal show={pixModal} onHide={() => {return false}} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header className="justify-content-center border-bottom-0">
					<Modal.Title id="contained-modal-title-vcenter">
						{pixModalLoading ? 'Gerando Pix' : 'Pagamento PIX'}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<Container>
						{pixModalLoading && <div className="justify-content-center align-items-center text-center p-2">
							<Spinner animation="border" role="status"/>
							<p className="mt-4">Executando operação, aguarde um momento</p>
						</div>
						}
						{!pixModalLoading && <div>
							{pixModalAlertMessage && <Row>
								<Alert className="d-flex" variant={pixModalAlert ? pixModalAlert : ''}>
									<Col md={2} className="justify-content-center align-items-center d-flex">
										<span className="material-icons alert-icon">{pixModalAlertIconName}</span>
									</Col>
									<Col md={10} className="align-items-center d-flex">
										<p className="p-0 m-0 color-white">{pixModalAlertMessage}</p>
									</Col>
								</Alert>
							</Row>}
							{pixModalQRCODE && <Row>
								<Col md={12}>
									<Col md={12}>
										<h6 className="text-center">Utilize o PIX QRCODE abaixo ou o PIX COPIA E COLA para efetuar o pagamento no aplicativo do seu banco digital</h6>
									</Col>
									<Col md={12} className="mt-4">
										<h6 className="text-center">PIX QR CODE</h6>
									</Col>
									<Col md={12} className="text-center justify-content-center d-flex mt-4">
										<QRCode value={pixModalQRCODE ? pixModalQRCODE : ''} size={250}/>
									</Col>
									<Col md={12} className="mt-4">
										<h6 className="text-center">PIX COPIA E COLA</h6>
									</Col>
									<Col md={12} className="mt-4">
										<p className="text-center text-break">{pixModalQRCODE}</p>
										<CopyToClipboard
											text={pixModalQRCODE ? pixModalQRCODE : ''}
											onCopy={() => {
													handleSetAlert({
														visible: true,
														variant: 'success',
														message: "Código copiado com sucesso",
														timeout: 5000
													});
												}
											}
										>
											<Button variant="primary d-flex justify-content-center" className="w-100">Copiar</Button>
										</CopyToClipboard>
									</Col>
								</Col>
							</Row>}
						</div>
						}
					</Container>
				</Modal.Body>
				{!pixModalLoading && <Modal.Footer className="border-top-0">
					<Button variant="light" onClick={() => pixModalCancel ? history.push('/login') : setPixModal(false)}>Fechar</Button>
				</Modal.Footer>}
			</Modal>

			{/* PAGAMENTO CARTAO DE CREDITO */}
			<Modal show={paymentModal} onHide={() => {return false}} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header className="justify-content-center border-bottom-0">
					<Modal.Title id="contained-modal-title-vcenter">
						{paymentModalLoading ? 'Efetuando pagamento' : 'Pagamento Cartão de Crédito'}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<Container>
						{paymentModalLoading && <div className="justify-content-center align-items-center text-center p-2">
							<Spinner animation="border" role="status"/>
							<p className="mt-4">Executando operação, aguarde um momento</p>
						</div>
						}
						{!paymentModalLoading && <div>
							{paymentModalAlertMessage && <Row>
								<Alert className="d-flex" variant={paymentModalAlert ? paymentModalAlert : ''}>
									<Col md={2} className="justify-content-center align-items-center d-flex">
										<span className="material-icons alert-icon">{paymentModalAlertIconName}</span>
									</Col>
									<Col md={10} className="align-items-center d-flex">
										<p className="p-0 m-0 color-white">{paymentModalAlertMessage}</p>
									</Col>
								</Alert>
							</Row>}
						</div>
						}
					</Container>
				</Modal.Body>
				{!paymentModalLoading && <Modal.Footer className="border-top-0">
					<Button variant="light" onClick={() => paymentModalCancel ? history.push('/login') : setPaymentModal(false)}>Fechar</Button>
				</Modal.Footer>}
			</Modal>
		</>
	);
}
